/* WhatsAppButton - Floating bottom-right WhatsApp chat button using the WhatsApp logo, with a hover label and click tracking.
   Updated: Lowered the button, added a solid #199d0d green circle behind the logo and removed the pulse animation.
   Updated: Links to the main number +31 85 02 33 564. */

import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { trackGoal } from '@/lib/datafast';

const WHATSAPP_URL = 'https://wa.me/31850233564';
const HIDDEN_PATH_PREFIXES = ['/kh-admin', '/winkelwagen/afrekenen'];

export default function WhatsAppButton() {
  const { pathname } = useLocation();

  if (HIDDEN_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return null;

  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat met ons via WhatsApp"
      onClick={() => trackGoal('contact_engagement_clicked', { type: 'whatsapp', source: 'floating_button' })}
      initial={{ opacity: 0, scale: 0.6, y: 12 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 0.6, type: 'spring', stiffness: 260, damping: 20 }}
      className="group fixed bottom-20 right-6 z-50 flex items-center sm:bottom-24"
    >
      <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full bg-white px-4 py-2 text-sm font-medium text-[#1e2b22] opacity-0 shadow-[0_8px_24px_rgba(0,0,0,0.16)] transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 sm:block sm:translate-x-2">
        Vragen? App ons!
      </span>
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#199d0d] p-1.5 shadow-[0_8px_24px_rgba(0,0,0,0.28)] transition-transform duration-300 group-hover:scale-110 group-active:scale-95">
        <img
          src="/assets/logo-whatsapp.webp"
          alt="WhatsApp"
          width={44}
          height={44}
          className="h-full w-full rounded-full object-contain"
        />
      </span>
    </motion.a>
  );
}
